/**
 * Retainer module navigation — Wave 6, spec-03.
 * Full entry mirroring modules/setup/navigation.ts shape.
 * Routes: /retainer (list), /retainer/:id, /retainer/timesheet,
 *         /retainer/renewals, /retainer/overages
 *
 * NOTE: /retainer/portfolio removed — PortfolioPage component does not exist.
 * Re-add when PortfolioPage is implemented (spec-03 deferred).
 */
import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

export const retainerNavigation: ModuleNavigation = [
  {
    title: 'الرئيسية — Overview',
    items: [
      { path: '/retainer/dashboard', label: 'لوحة التحكم — Dashboard' },
      { path: '/retainer/list', label: 'العقود — Contracts' },
    ],
  },
  {
    title: 'الإدارة — Management',
    items: [
      { path: '/retainer/timesheet', label: 'الجدول الأسبوعي — Timesheet' },
      { path: '/retainer/renewals', label: 'التجديدات — Renewals' },
      { path: '/retainer/overages', label: 'سجل التجاوز — Overages' },
    ],
  },
];
